import React, {Component} from 'react';
import {connect} from 'react-redux';

import VatReturnFilingValues from './VatReturn/FilingValues';
import EcListingFilingValues from './EcListing/FilingValues';
import LocalListingFilingValues from './localListing/FilingValues';
import IntrastatFilingValues from './Intrastat/FilingValues';
import FilingValuesForGenericReturns from './Generic/FilingValues';
import VATBookFilingValues from './VatBook/FilingValues';
import ReverseChargeListingFilingValues from './reverseChargeListing/FilingValues';
import ExtrastatFilingValues from './Extrastat/FilingValues';
import OSSFilingValues from './Oss/OSSFilingValues';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import {FilingTypeEnum} from '../../utils/enums';

const log = new Logger('FILING_VALUES', LOG_LEVELS.DEBUG);

class FilingValues extends Component {
  render() {
    log.debug('render(): ', this.props);

    return (
        <s-row>
          <s-col span="12">
            {
              ((filingTypeId) => {
                switch (filingTypeId) {
                  case FilingTypeEnum.VATRETURN:
                    return (<VatReturnFilingValues
                        countryCode={this.props.countryCode}
                        companyId={this.props.companyId}
                        filingPeriod={this.props.filingPeriod}
                        filingDueDate={this.props.dueDate}
                        filingValues={this.props.filingValues}
                        vatBoxDetail={this.props.filingValueDetail}
                        frequency={this.props.frequency}
                        isEditable="false"
                        returnDisplayType={this.props.returnDisplayType}
                        selectedCorrectionPeriod={this.props.selectedCorrectionPeriod}
                      />);
                  case FilingTypeEnum.ECLISTING:
                    return (<EcListingFilingValues
                      countryCode={this.props.countryCode}
                      companyId={this.props.companyId}
                      filingPeriod={this.props.filingPeriod}
                      filingDueDate={this.props.dueDate}
                      filingValues={this.props.filingValues}
                      frequency={this.props.frequency}
                      onReportChangeHandler={this.props.onReportChangeHandler}
                      selectedReportType={this.props.selectedReportType}
                      vatNumber={this.props.vatNumber}
                      loading={this.props.filingLoading}
                    />);
                    //For Intra In && Intra Out
                    case FilingTypeEnum.INTRASTAT:
                    return (<IntrastatFilingValues
                            countryCode={this.props.countryCode}
                            companyId={this.props.companyId}
                            filingPeriod={this.props.filingPeriod}
                            filingDueDate={this.props.dueDate}
                            filingValues={this.props.filingValues}
                    />);
                  case FilingTypeEnum.LOCALLISTING:
                      return (
                        <LocalListingFilingValues
                          countryCode={this.props.countryCode}
                          companyId={this.props.companyId}
                          filingPeriod={this.props.filingPeriod}
                          filingDueDate={this.props.dueDate}
                          filingValues={this.props.filingValues}
                          frequency={this.props.frequency}
                          onReportChangeHandler={this.props.onReportChangeHandler}
                          selectedReportType={this.props.selectedReportType}
                          vatNumber={this.props.vatNumber}
                        />);

                  case FilingTypeEnum.REVERSECHARGELISTING:
                        return (
                          <ReverseChargeListingFilingValues
                            countryCode={this.props.countryCode}
                            companyId={this.props.companyId}
                            filingPeriod={this.props.filingPeriod}
                            filingDueDate={this.props.dueDate}
                            filingValues={this.props.filingValues}
                            frequency={this.props.frequency}
                            selectedReportType={this.props.selectedReportType}
                            onReportChangeHandler={this.props.onReportChangeHandler}
                            vatNumber={this.props.vatNumber}
                        />);

                  case FilingTypeEnum.VATBOOKS:
                        return (
                          <div>
                            <VATBookFilingValues 
                              countryCode={this.props.countryCode}
                              companyId={this.props.companyId}
                              filingPeriod={this.props.filingPeriod}
                              filingDueDate={this.props.dueDate}
                              filingValues={this.props.filingValues}
                              frequency={this.props.frequency}
                              onReportChangeHandler={this.props.onReportChangeHandler}
                              selectedReportType={this.props.selectedReportType}
                              selectedCorrectionPeriod={this.props.selectedCorrectionPeriod}
                            />
                          </div>  
                        );  
                  case FilingTypeEnum.EXTRASTAT:
                        return (<ExtrastatFilingValues
                                countryCode={this.props.countryCode}
                                companyId={this.props.companyId}
                                filingPeriod={this.props.filingPeriod}
                                filingDueDate={this.props.dueDate}
                                filingValues={this.props.filingValues}
                                onReportChangeHandler={this.props.onReportChangeHandler}
                                selectedReportType={this.props.selectedReportType}
                        />);
                  case FilingTypeEnum.OSSIMPORT:
                  case FilingTypeEnum.OSSUNION:
                  case FilingTypeEnum.OSSNONUNION:
                        return (<OSSFilingValues
                            filingValues={this.props.filingValues}
                            selectedGroupType={this.props.selectedGroupType}
                            onGroupTypeChangeHandler={this.props.onGroupTypeChangeHandler}
                            fileName={this.props.filename}
                        />);
                  default:
                    return (<FilingValuesForGenericReturns
                        countryCode={this.props.countryCode}
                        companyId={this.props.companyId}
                        filingPeriod={this.props.filingPeriod}
                        filingDueDate={this.props.dueDate}
                        filingValues={this.props.filingValues}
                    />)

                }
              })(this.props.filingTypeId)
            }
          </s-col>
        </s-row>
    );
  }

}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  }
}




// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FilingValues);
